var map = {
	"./cityray/blue.png": "6871",
	"./cityray/grey.png": "d3af",
	"./cityray/light-grey.png": "cad3",
	"./cityray/white.png": "7729",
	"./emgrand/black.png": "9e4b",
	"./emgrand/cyan.png": "2f13",
	"./emgrand/gold.png": "2d43",
	"./emgrand/grey.png": "19ec",
	"./emgrand/lilac.png": "c696",
	"./emgrand/white.png": "d833",
	"./ex5/black.png": "9526",
	"./ex5/blue.png": "30e5",
	"./ex5/dark-grey.png": "7c11",
	"./ex5/grey.png": "15e8",
	"./ex5/white.png": "9454",
	"./okavango/black.png": "16ae",
	"./okavango/blue.png": "d385",
	"./okavango/grey.png": "29b3",
	"./okavango/white.png": "7c3a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a2d5";